import { Check, Clock, Ban } from "lucide-react";

export const DECISION_RING = {
  approved: "ring-emerald-500", scheduled: "ring-emerald-500", published: "ring-emerald-500",
  pending_approval: "ring-amber-400", changes_requested: "ring-amber-400", rejected: "ring-rose-500",
};

const OPTS = [
  { status: "approved", label: "Freigeben", icon: Check, on: "bg-emerald-500 text-white border-emerald-500", off: "border-emerald-500/50 text-emerald-400" },
  { status: "pending_approval", label: "Offen", icon: Clock, on: "bg-amber-400 text-slate-950 border-amber-400", off: "border-amber-400/50 text-amber-300" },
  { status: "rejected", label: "Sperren", icon: Ban, on: "bg-rose-500 text-white border-rose-500", off: "border-rose-500/50 text-rose-400" },
];

export default function DecisionButtons({ post, onDecide, busy }) {
  const current = ["scheduled"].includes(post.status) ? "approved" : post.status === "changes_requested" ? "pending_approval" : post.status;
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={`decision-buttons-${post.id}`}>
      {OPTS.map(({ status, label, icon: Icon, on, off }) => (
        <button key={status} disabled={busy || post.status === "published"} onClick={() => status !== current && onDecide(status)}
          className={`h-11 rounded-lg border-2 text-[13px] font-semibold flex items-center justify-center gap-1 px-1 transition-colors active:scale-[0.97] disabled:opacity-60 ${current === status ? on : `bg-transparent ${off}`}`}
          data-testid={`decide-${status}-${post.id}`}>
          <Icon className="h-3.5 w-3.5 shrink-0" />{label}
        </button>
      ))}
    </div>
  );
}
